import { render } from "./createProject1.vue?vue&type=template&id=5defd58e&scoped=true"
import script from "./createProject1.vue?vue&type=script&lang=js"
export * from "./createProject1.vue?vue&type=script&lang=js"

import "./createProject1.vue?vue&type=style&index=0&id=5defd58e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5defd58e"]])

export default __exports__